import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { BASE_URL } from '@/api/constant';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  transitional: {
    clarifyTimeoutError: true,
  },
});

axiosInstance.interceptors.request.use(
  async function (config) {
    const idToken = await getAuth().currentUser?.getIdToken();
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  function (error) {
    console.error('ResponseInterceptor::', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
